<template>
  <div class="app-section-header">
    <span class="app-section-header__bar"></span>
    <span class="app-section-header__label">{{ label }}</span>
    <v-chip v-if="count !== null" x-small color="primary" text-color="white" class="ml-2 font-weight-bold">
      {{ count }}
    </v-chip>
    <v-spacer></v-spacer>
    <slot name="actions"></slot>
  </div>
</template>

<script>
export default {
  name: "AppSectionHeader",
  props: {
    label: { type: String, required: true },
    count: { type: [Number, String], default: null },
  },
};
</script>

<style scoped>
.app-section-header {
  display: flex;
  align-items: center;
  margin: 20px 0 12px;
}
.app-section-header__bar {
  width: 4px;
  height: 16px;
  border-radius: 2px;
  background: var(--color-primary);
  margin-right: 10px;
}
.app-section-header__label {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--color-ink);
  opacity: 0.75;
}
</style>
